module.exports = __webpack_public_path__ + "img/icon-note-light-gray.901a21dc.svg";